// @flow

import * as actions from "@modules/service/constants/actions";
import * as pagesReducers from "./reducers";
import { pagesInitialState } from "./state";
import type { PagesState } from "./types";
import { cloneObject } from "@utils/object";

export const pages = (state: PagesState = pagesInitialState, action: Object): Object => {
  const act = {
    [actions.GetEventsCount]: pagesReducers.onGetEventsCount,
    [actions.GetEventsCountSuccess]: pagesReducers.onGetEventsCountSuccess,
    [actions.GetEventsCountError]: pagesReducers.onGetEventsCountError,

    [actions.GetClassificationsCount]: pagesReducers.onGetClassificationsCount,
    [actions.GetClassificationsCountSuccess]: pagesReducers.onGetClassificationsCountSuccess,
    [actions.GetClassificationsCountError]: pagesReducers.onGetClassificationsCountError,

    [actions.GetPromptsCount]: pagesReducers.onGetPromptsCount,
    [actions.GetPromptsCountSuccess]: pagesReducers.onGetPromptsCountSuccess,
    [actions.GetPromptsCountError]: pagesReducers.onGetPromptsCountError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
